declare const window: any;
declare const $dom: any;


export class imenh {

    private breakpoints: Array<number> = window.imgEnhancerBreakpoints; // the only possible image widths (loaded from configuration as global value)
    private enhancerInitTimeout: any; // first init
    private screenDensity: any = window.imageDensity;
    private multiplied = false;

    /**
     * Initialization of module. This module is expected to be used as single instance on page.
     * @return  {boolean}      TRUE/FALSE if the initialization was successful or not (boolean)
     */
    initGlobal(): boolean {
        this.enhancerInitTimeout = setTimeout(this.firstInitEvent, 0);
        //this.firstInitEvent()
        window.addEventListener('scrollStartRfe', this.viewportChangeEvent);
        window.addEventListener('scrollEndRfe', this.viewportChangeEvent);
        window.addEventListener('resize', this.viewportChangeEvent);
        window.addEventListener('showOverlayRfe', this.viewportChangeEvent);
        window.addEventListener('playerRendered', this.viewportChangeEvent);

        // the instance of module has been initialized => return TRUE
        return true;
    }

    /**
     * De-initialization of module
     */
    deinitGlobal(): void {
        clearTimeout(this.enhancerInitTimeout);
        window.removeEventListener('scrollStartRfe', this.viewportChangeEvent);
        window.removeEventListener('scrollEndRfe', this.viewportChangeEvent);
        window.removeEventListener('resize', this.viewportChangeEvent);
        window.removeEventListener('showOverlayRfe', this.viewportChangeEvent);
        window.removeEventListener('playerRendered', this.viewportChangeEvent);
    }

    /**
     * It will do enhancement of enhanceable elements inside of parent element.
     * @param   {HTMLElement}   context                 Parent element for searching target elements (DOM object)
     * @param   {boolean}       justNotEnhancedImages   check if '.enhance' has been applied (Boolean)
     * @param   {boolean}       [allowStretch=true]     defines, if image can be stretched (default is true) (Boolean)
     */
    processEnhanceableElements = (context: HTMLElement, justNotEnhancedImages: boolean, allowStretch: boolean = true): void => {
        const elements: Array<Element> = this.getEnhanceableElements(context);
        for (let i = 0; i < elements.length; i++) {
            const image = elements[i] as HTMLImageElement | HTMLVideoElement;
            this.processEnhancement(image, justNotEnhancedImages, allowStretch);
        }
    }

    /**
     * It will do enhancement of the image
     * @param   {(HTMLImageElement)}     image                   target DOM image (HTMLImageElement)
     * @param   {boolean}                                   justNotEnhancedImages   check if '.enhance' has been applied (Boolean)
     * @param   {boolean}                                   [allowStretch=true]     defines, if image can be stretched (default is true) (Boolean)
     * @return  {string}                                                            new SRC of the image (string)
     */
    processEnhancement = (image: HTMLImageElement | HTMLVideoElement, justNotEnhancedImages: boolean, allowStretch: boolean = true): string => {
        let sourceAttr: string = 'src';
        let src: string | null = image.getAttribute(sourceAttr);
        const dataSrc = image.getAttribute('data-' + sourceAttr) as string;
        const isVideo: boolean = image.nodeName === 'VIDEO';
        if (isVideo) {
            sourceAttr = 'poster';
        }
        if (!src) {
            src = dataSrc;
        }

        // video poster specific things
        if (image.parentElement?.classList.contains('c-mmp__poster--video')) {
            //video frame or uploaded image
            if (src?.includes('_tv')) {
                src = src.replace('_b1', '').replace('_r1', '_r0');
            }
            else {
                // get aspect ratio
                const aspectRatio = $dom.ancestor(image, '.c-mmp').querySelector('video')?.getAttribute('data-aspect-ratio')?.split('/');

                // vertical teaser
                if (image.classList.contains('c-mmp__poster-image-v') && aspectRatio) {
                    src = src.replace(/_r\d/i, '');
                    if (src.includes('_h')) {
                        src = src.replace(/_w\d*/i, '_w' + aspectRatio[0]);
                    }
                    else {
                        src = src.replace(/_w\d*/i, '_w' + aspectRatio[0] + '_h' + aspectRatio[1]);
                    }
                }


                if(image.classList.contains('c-mmp__poster-image-h') && aspectRatio) {
                    //horizontal teaser
                    if ((RFE.getResponsiveState() === 'xs' || $dom.ancestor(image, '.c-mmp--embed-vertical')) && !src.includes('_h')) { 
                        // make it vert
                        image.classList.remove('enhanced');
                        src = src.replace(/_r\d/i, '');
                        src = src.replace(/_w\d*/i, '_w' + aspectRatio[0] + '_h' + aspectRatio[1]);
                    }

                    if (RFE.getResponsiveState() !== 'xs' || $dom.ancestor(image, '.c-mmp--embed-vertical')) {
                        // make it horizontal
                        src = src.replace(/_r\d/i, '');
                        src = src.replace(/_h\d*/i, '').replace(/_w\d*/i, src.match(/_w\d*/i) + '_r1');
                        image.classList.remove('enhanced');
                    }
                    
                }
            }
        }

        const newUrl: string | boolean | null = this.getRightImageURL(src, image, justNotEnhancedImages, allowStretch);

        if (typeof newUrl === 'string') {
            (function (image) {
                // RESP-4543: this timeout needs to be set because of smooth lazy load in Chrome
                setTimeout( () => {
                    if (!$dom.ancestor(image, '.img-wrap--infographics')) {
                        $dom.addClass(image, 'enhanced');
                    }
                    else {
                        $dom.addClass(image, 'enhanced--infographic');
                    }
                }, 10);
            })(image);

            if (isVideo) {
                image.setAttribute('poster', newUrl);
            }
            else {
                image.src = newUrl;
            }
        }

        return image.src;
    }

    /**
     * Decide if image will be enhanced.
     * @param   {string}                                    src                     Original SRC (String)
     * @param   {(HTMLImageElement | HTMLVideoElement)}     image                   Image object (DOM object)
     * @param   {boolean}                                   justNotEnhancedImages   check if '.enhance' has been applied (Boolean)
     * @param   {boolean}                                   [allowStretch=true]     defines, if image can be stretched (default is true) (Boolean)
     * @return  {(string | null | boolean)}                                         Returns {string} new src or {null} if the src given is good enough. If there is any problem (can not process source) it returns {false}.
     */
    getRightImageURL = (src: string, image: HTMLImageElement | HTMLVideoElement, justNotEnhancedImages: boolean, allowStretch: boolean = true): string | null | boolean => {
        const origin: RegExpExecArray | null = /_w([0-9]{2,5})/g.exec(src);

        if (!origin || !origin[1]) { // The URL given is not able to be parsed
            // var title = 'N/A'
            return false;
        }
        else if ($dom.hasClass(image, 'live-tracker-image')) { // live tracker image not to be displayed
            return false;
        }
        else { // the url given is ready to be parsed
            if (allowStretch === undefined) {
                allowStretch = true;
            }
            const originWidth: any = parseInt(origin[1]);
            let areaWidth: number = image.offsetWidth;

            const firstParent: HTMLElement = $dom.ancestor(image);
            if (firstParent.className.indexOf('thumb') > -1) {
                // PANGEA-7065 Image Display Problems - fixes issue with the small image
                // for some reason the image without src attribute has width 16 no matter of the CSS.
                // In this case we use the width of the parent element
                areaWidth = Math.max(firstParent.offsetWidth, areaWidth);
            }

            const secondParent: HTMLElement = $dom.ancestor(firstParent);
            if (secondParent && secondParent.className.indexOf('c-lightbox__img') > -1) {
                // for the lightbox we need to get dimensions from next parent element (wrapper for lightbox image)
                areaWidth = Math.max(secondParent.offsetWidth, areaWidth);
            }
            // don't enhance images which are not visibble at the moment, hidden on newslayout for example
            if (!areaWidth) {
                return false;
            }
            // fix small images after click on load more button (photoblog page)
            if ($dom.hasClass(document.body, 'pg-photoblog') && typeof image === 'object' && areaWidth === 0) {
                return false;
            }
            const areaWidthInfo = areaWidth * 2;
            let wantedWidth: number = -1; // originally was (originWidth * 3);
            let oneUp: number = -1;
            let credFSMultipl = 0;
            const srcExt = /\..{1,5}$/g.exec(src);

            if (this.screenDensity) {
                if (window.devicePixelRatio) {
                    if (window.devicePixelRatio > 1) {
                        credFSMultipl = Math.ceil(window.devicePixelRatio);
                        areaWidth = Math.floor(areaWidth * window.devicePixelRatio);
                        this.multipyBreakPoints(window.devicePixelRatio);
                    }
                }
                else {
                    credFSMultipl = Math.ceil(this.screenDensity);
                    areaWidth = areaWidth * this.screenDensity;
                    this.multipyBreakPoints(this.screenDensity);
                }

                if (credFSMultipl && srcExt && srcExt[0]) {
                    const hasFontMulti = src.match(/_d\d/g) || [];
                    src = hasFontMulti.length
                        ? src.replace(/_d\d/g, '_d' + credFSMultipl)
                        : src.replace(srcExt[0], '_d' + credFSMultipl + srcExt[0]);
                }
            }

            // looking for the best breakpoints
            for (let j = this.breakpoints.length - 1; wantedWidth === -1 && j > -1; j--) {
                const breakpoint: number = this.breakpoints[j];

                if (breakpoint <= areaWidth) { // ok, we found a right gap
                    if ((oneUp !== -1 && areaWidth > breakpoint * 1.1) || areaWidth === 0) { // if the size is more than 110% of the breakpoint take the bigger
                        wantedWidth = oneUp;
                    }
                    else {
                        wantedWidth = breakpoint;  // take the breakpoint because it's acceptable
                    }
                }
                oneUp = breakpoint; // save previous breakpoint
            }
            if (secondParent && secondParent.className.indexOf('img-wrap--infographics') > -1) {
                wantedWidth = areaWidthInfo; // setting double for static infographics
            }

            const pos: number = origin.index + 2; // '2' means position - '_w'
            const loadable: boolean = this.canBeLoaded(originWidth, areaWidth, wantedWidth, src, image, justNotEnhancedImages);

            if (wantedWidth > -1 && loadable) { // load that finally or not ?
                // change quality if it is so small
                src = src.replace('_q10', '');
                const aspectRatio = $dom.ancestor(image, '.c-mmp')?.querySelector('video')?.getAttribute('data-aspect-ratio')?.split('/');
                if (src.includes('_h') && aspectRatio?.length === 2) {
                    const retValWithHeight = src.substring(0, pos) + wantedWidth.toString() + ((!allowStretch) ? '_n' : '') + src.substring(pos + originWidth.toString().length) as string;
                    const resultHeight = wantedWidth * (aspectRatio[1]/aspectRatio[0]);
                    return retValWithHeight.replace(/_h\d*/i, '_h' + Math.ceil(resultHeight));
                }

                const retVal = src.substring(0, pos) + wantedWidth.toString() + ((!allowStretch) ? '_n' : '') + src.substring(pos + originWidth.toString().length) as string;
                return retVal;
            }
            else {
                return null;
            }
        }
    }

    multipyBreakPoints = (multiplicator): void => {
        if (!this.multiplied) {
            const breakpointTempArr: Array<number> = [];
            for (let a = 0; a < this.breakpoints.length; a++) {
                const value = Math.floor(this.breakpoints[a] * multiplicator);
                breakpointTempArr.push(value);
            }
            this.breakpoints = breakpointTempArr;
            this.multiplied = true;
        }
    }

    /**
     * Finds enhanceable elements in context of document body which were not enhanced yet and process them.
     * Images can be stretched.
     */
    viewportChangeEvent = (): void => {
        this.processEnhanceableElements(document.body, true, true);
    }

    /**
     * Finds enhanceable elements in context of document body and process them.
     * Images can be stretched.
     */
    firstInitEvent = (): void => {
        this.processEnhanceableElements(document.body, true, true);
    }

    /**
     * Returns all image and video element from target element which can be enhanced.
     * @param   {HTMLElement}           context     Parent element for searching target elements (HTMLElement)
     * @return  {Array<HTMLElement>}                NodeList or array of HTML elements
     */
    getEnhanceableElements = (context: HTMLElement): Array<Element> => {
        const allElements = context.querySelectorAll('img, video[poster]');
        const enhancerElements: Array<Element> = []; // filtered items

        for (let i = 0; i < allElements.length; i++) {
            const image = allElements[i];

            if (!image) {
                continue;
            }

            if (image.nodeName === 'IMG') {
                image.getBoundingClientRect().height && image.setAttribute('height', image.getBoundingClientRect().height.toFixed());
                image.getBoundingClientRect().width && image.setAttribute('width', image.getBoundingClientRect().width.toFixed());
            }

            // disable the processing for specific images
            if ($dom.hasClass(image, 'dont-enhance')) {
                continue;
            }

            // check if the image is visible (in the viewpoint or upper)
            if (!this.isWithinViewport(image) && !RFE.isMobile.Opera()) {
                continue;
            }

            enhancerElements.push(image); // the image is enhanceable
        }
        return enhancerElements;
    }

    /**
     * Determines whether an element is within the viewport
     *
     * @param   {Element}   el   Tested HTML element (DOM object)
     * @return  {boolean}       TRUE/FALSE if the element is within the viewport or not (boolean)
     */
    isWithinViewport = (el: Element): boolean => {
        const rect = el.getBoundingClientRect();
        return rect.top < (window.innerHeight || document.body.clientHeight) && rect.left < (window.innerWidth || document.body.clientWidth);
    }

    /**
     * Determines if the image can be loaded (enhanced).
     * @param   {number}                                    originWidth             Current Image size (Number)
     * @param   {number}                                    areaWidth               Node IMG size (Number)
     * @param   {number}                                    wantedWidth             New decided width (Number)
     * @param   {string}                                    src                     Original SRC (String)
     * @param   {(HTMLImageElement | HTMLVideoElement)}     img                     Image object (DOM object)
     * @param   {boolean}                                   justNotEnhancedImages   check if '.enhance' has been applied (Boolean)
     * @return  {boolean}                                                           Returns Boolean. If returns true the image will be loaded
     * @todo    Constants for areas: is in viewport, is the connection fast, ...
     */
    canBeLoaded = (originWidth: number, areaWidth: number, wantedWidth: number, src: string, img: HTMLImageElement | HTMLVideoElement, justNotEnhancedImages: boolean): boolean => {

        if (src !== img.src) { //img.classList.contains('c-mmp__poster-image-h')
            return true;
        }
        if (src.indexOf('_q10') > -1) { // wrong image quality, to be enhanced
            return true;
        }
        if (originWidth === wantedWidth) { // don't load when it's already same sized
            return false;
        }
        else if (justNotEnhancedImages && $dom.hasClass(img, 'enhanced')) { // it is already enhanced, skip that
            return false;
        }
        else if (originWidth / wantedWidth >= 0.9 && !!img.src) { // don't load when it's only less that 10% smaller
            return false;
        }
        return true; // let's load the image
    }
}

const imenhc = new imenh();
export default imenhc;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./source/js/helpers/image_enhancer.ts